import React from "react"
import { AppDispatch } from "../../../reduxStore/store"
import {
  ErrorState,
  selectErrorHandler,
  initialState as initialActionNeededState,
  errorHandlerUpdated,
} from "../errorSlice"
import { useDispatch, useSelector } from "react-redux"
import cn from "../../../utils/classes"
import { Banner } from "../../shared/components/Banner"

interface ActionNeededBannerProps {
  styleOverrides?: string
  disableClose?: boolean
}

/**
 * @deprecated Use BannerWithId and bannersWithId state instead. This component uses the legacy actionNeededBanner state.
 */
export const ActionNeededBanner: React.FC<ActionNeededBannerProps> = ({
  disableClose,
  styleOverrides,
}) => {
  const dispatch: AppDispatch = useDispatch()

  const errorState: ErrorState = useSelector(selectErrorHandler)

  const actionNeededBannerState = errorState.actionNeededBanner

  const handleOnBannerClose = () => {
    const payload: Partial<ErrorState> = {
      actionNeededBanner: initialActionNeededState.actionNeededBanner,
    }
    dispatch(errorHandlerUpdated(payload))

    actionNeededBannerState.onClose?.()
  }

  const className = cn(styleOverrides)

  return (
    <Banner
      type="actionNeeded"
      title={actionNeededBannerState.title}
      content={actionNeededBannerState.content}
      isOpen={actionNeededBannerState.isVisible}
      onClose={disableClose ? undefined : handleOnBannerClose}
      id="profile-card"
      sticky={true}
      styleOverrides={`${className} z-10`}
      contentStyleOverrides="text-base"
      titleStyleOverrides="text-base"
    />
  )
}

export default ActionNeededBanner
